import { processInclude } from 'util/common';

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./findYourSize/findYourSize'));

    $('#calculate').on('click', function (e) {
        var inputUnderbrowSize = $('#contact-form-question-underbrow').val();
        var inputCupSize = $('#contact-form-question-cup').val();

        if (inputUnderbrowSize != undefined && inputCupSize != undefined && inputUnderbrowSize != '' && inputCupSize != '') {
            e.preventDefault();
            var jsonUnderbrowTable = window.FindYourSizeData.findYourSizeData;
            var underbrowTable = JSON.parse(jsonUnderbrowTable);
            var intUnderbrowSize = parseInt(inputUnderbrowSize);
            var intCupSize = parseInt(inputCupSize);
            calculateBraSize(intUnderbrowSize, intCupSize, underbrowTable);
        }
    });

    // Calculate modal from pdp - plp
});

// function modal from pdp - plp

function calculateBraSize (inputUnderbrowSize, inputCupSize, underbrowTable) {
    var country = $('#countrySelector').attr('data-country');
    var jsonCircTable = window.FindYourSizeDataCirc.findYourSizeDataCirc;
    var circTable = JSON.parse(jsonCircTable);
    var underbrowSize;
    var cupSize;
    var eu = false;
    for (var key in underbrowTable) {
        if (inputUnderbrowSize >= underbrowTable[key].from && inputUnderbrowSize <= underbrowTable[key].to) {
            switch (country) {
            case 'it':
                underbrowSize = underbrowTable[key].it;
                break;
            case 'es':
                underbrowSize = underbrowTable[key].es;
                break;
            case 'fr':
                underbrowSize = underbrowTable[key].fr;
                break;
            case 'us':
                underbrowSize = underbrowTable[key].us;
                break;
            case 'gb':
                underbrowSize = underbrowTable[key].gb;
                break;
            case 'pt':
                underbrowSize = underbrowTable[key].pt;
                break;
            case 'hk':
                underbrowSize = underbrowTable[key].hk;
                break;
            case 'lu':
                underbrowSize = underbrowTable[key].lu;
                break;
            default:
                eu = true;
                underbrowSize = underbrowTable[key].eu;
                break;
            }
        }
    }

    if (eu == true) {
        country = 'eu';
    }
    for (var k in circTable[country + '_' + underbrowSize]) {
        if (inputCupSize >= circTable[country + '_' + underbrowSize][k].from && inputCupSize <= circTable[country + '_' + underbrowSize][k].to) {
            cupSize = k;
            break;
        }
    }

    if (underbrowSize != undefined && cupSize != undefined) {
        switch (country) {
        case 'it':
            cleanTable();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTable(underbrowSize, cupSize);
            break;
        case 'es':
            cleanTableESFRLU();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTableESFRLU(underbrowSize, cupSize);
            break;
        case 'fr':
            cleanTableESFRLU();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTableESFRLU(underbrowSize, cupSize);
            break;
        case 'lu':
            cleanTableESFRLU();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTableESFRLU(underbrowSize, cupSize);
            break;
        case 'us':
            cleanTableUS();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTableUS(underbrowSize, cupSize);
            break;
        case 'gb':
            cleanTableUK();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTableUK(underbrowSize, cupSize);
            break;
        case 'hk':
            cleanTableHK();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTableHK(underbrowSize, cupSize);
            break;
        case 'pt':
            cleanTablePT();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTablePT(underbrowSize, cupSize);
            break;
        default:
            cleanTableEU();
            $('#measure-not-valid').hide();
            $('#bra-results').show();
            $('#box-result-size').show();
            document.getElementById('bra-results').innerHTML = underbrowSize + cupSize;
            $('#box-message-size').removeAttr('hidden');
            $('#tableSize').removeAttr('hidden');
            $('.table-' + country).removeClass('hidden');
            calculateTableEU(underbrowSize, cupSize);
            break;
        }
    } else {
        $('#bra-results').hide();
        $('#measure-not-valid').show();
        $('#box-result-size').show();
    }
}

function calculateTable (underbrowSize, cupSize) {
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];
    var id = '' + underbrowSize + cupSize;
    $("[id='" + id + "']").text(id);
    $("[id='" + id + "']").addClass('size-active');

    for (var i = underbrowSize; i < 6; i++) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 1;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }

    for (var i = initialUnderBrowSize; i > 1; i--) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 1;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }
}

function cleanTable () {
    var underbrowSize = ['1', '2', '3', '4', '5', '6'];
    var cupSize = ['A', 'B', 'C', 'D', 'E', 'F'];
    for (var i = 0; i < cupSize.length; i++) {
        for (var j = 0; j < underbrowSize.length; j++) {
            var id = '' + underbrowSize[i] + cupSize[j];
            $("[id='" + id + "']").text('');
            $("[id='" + id + "']").removeClass('size-active');
            $("[id='" + id + "']").removeClass('size-same');
        }
    }
}

function calculateTableESFRLU (underbrowSize, cupSize) {
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];
    var id = '' + underbrowSize + cupSize;
    $("[id='" + id + "']").text(id);
    $("[id='" + id + "']").addClass('size-active');

    for (var i = underbrowSize; i < 105; i += 5) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 5;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }

    for (var i = initialUnderBrowSize; i > 80; i -= 5) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 5;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }
}

function cleanTableESFRLU () {
    var underbrowSize = ['80', '85', '90', '95', '100', '105'];
    var cupSize = ['A', 'B', 'C', 'D', 'E', 'F'];
    for (var i = 0; i < cupSize.length; i++) {
        for (var j = 0; j < underbrowSize.length; j++) {
            var id = '' + underbrowSize[i] + cupSize[j];
            $("[id='" + id + "']").text('');
            $("[id='" + id + "']").removeClass('size-active');
            $("[id='" + id + "']").removeClass('size-same');
        }
    }
}

function calculateTableUS (underbrowSize, cupSize) {
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'DD', 'DDD'];
    var id = '' + underbrowSize + cupSize;
    $("[id='" + id + "']").text(id);
    $("[id='" + id + "']").addClass('size-active');

    if (underbrowSize == 43) {
        underbrowSize = underbrowSize - 1;
    }
    for (var i = underbrowSize; i < 42; i += 2) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        if (PrevUnderbrowSize == 42) {
            PrevUnderbrowSize++;
        }
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }

    if (initialUnderBrowSize == 43) {
        initialUnderBrowSize = initialUnderBrowSize - 1;
    }
    for (var i = initialUnderBrowSize; i > 32; i -= 2) {
        if (initialCupSize == 'DDD') {
            break;
        }
        var PrevUnderbrowSize = i - 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }
}

function calculateTableUK (underbrowSize, cupSize) {
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'DD', 'F'];
    var id = '' + underbrowSize + cupSize;
    $("[id='" + id + "']").text(id);
    $("[id='" + id + "']").addClass('size-active');

    if (underbrowSize == 43) {
        underbrowSize = underbrowSize - 1;
    }
    for (var i = underbrowSize; i < 42; i += 2) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        if (PrevUnderbrowSize == 42) {
            PrevUnderbrowSize++;
        }
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }

    if (initialUnderBrowSize == 43) {
        initialUnderBrowSize = initialUnderBrowSize - 1;
    }
    for (var i = initialUnderBrowSize; i > 32; i -= 2) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }
}

function calculateTableHK (underbrowSize, cupSize) {
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];
    var id = '' + underbrowSize + cupSize;
    $("[id='" + id + "']").text(id);
    $("[id='" + id + "']").addClass('size-active');

    if (underbrowSize == 43) {
        underbrowSize = underbrowSize - 1;
    }
    for (var i = underbrowSize; i < 42; i += 2) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        if (PrevUnderbrowSize == 42) {
            PrevUnderbrowSize++;
        }
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }

    if (initialUnderBrowSize == 43) {
        initialUnderBrowSize = initialUnderBrowSize - 1;
    }
    for (var i = initialUnderBrowSize; i > 32; i -= 2) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }
}

function cleanTableUS () {
    var underbrowSize = ['32', '34', '36', '38', '40', '42'];
    var cupSize = ['A', 'B', 'C', 'D', 'DD', 'DDD'];
    for (var i = 0; i < cupSize.length; i++) {
        for (var j = 0; j < underbrowSize.length; j++) {
            var id = '' + underbrowSize[i] + cupSize[j];
            $("[id='" + id + "']").text('');
            $("[id='" + id + "']").removeClass('size-active');
            $("[id='" + id + "']").removeClass('size-same');
        }
    }
}
function cleanTableUK () {
    var underbrowSize = ['32', '34', '36', '38', '40', '42'];
    var cupSize = ['A', 'B', 'C', 'D', 'DD', 'F'];
    for (var i = 0; i < cupSize.length; i++) {
        for (var j = 0; j < underbrowSize.length; j++) {
            var id = '' + underbrowSize[i] + cupSize[j];
            $("[id='" + id + "']").text('');
            $("[id='" + id + "']").removeClass('size-active');
            $("[id='" + id + "']").removeClass('size-same');
        }
    }
}
function cleanTableHK () {
    var underbrowSize = ['32', '34', '36', '38', '40', '42'];
    var cupSize = ['A', 'B', 'C', 'D', 'E', 'F'];
    for (var i = 0; i < cupSize.length; i++) {
        for (var j = 0; j < underbrowSize.length; j++) {
            var id = '' + underbrowSize[i] + cupSize[j];
            $("[id='" + id + "']").text('');
            $("[id='" + id + "']").removeClass('size-active');
            $("[id='" + id + "']").removeClass('size-same');
        }
    }
}
function calculateTableEU (underbrowSize, cupSize) {
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];
    document.getElementById('' + underbrowSize + cupSize + 'eu').innerHTML = underbrowSize + cupSize;
    var hashId = '#' + underbrowSize + cupSize + 'eu';
    $(hashId).addClass('size-active');

    for (var i = underbrowSize; i < 95; i += 5) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 5;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        document.getElementById('' + id + 'eu').innerHTML = id;
        var hashId = '#' + id + 'eu';
        $(hashId).addClass('size-same');
    }

    for (var i = initialUnderBrowSize; i > 70; i -= 5) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 5;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        document.getElementById('' + id + 'eu').innerHTML = id;
        var hashId = '#' + id + 'eu';
        $(hashId).addClass('size-same');
    }
}

function cleanTableEU () {
    var underbrowSize = ['70', '75', '80', '85', '90', '95'];
    var cupSize = ['A', 'B', 'C', 'D', 'E', 'F'];
    for (var i = 0; i < cupSize.length; i++) {
        for (var j = 0; j < underbrowSize.length; j++) {
            var id = '' + underbrowSize[i] + cupSize[j] + 'eu';
            $("[id='" + id + "']").text('');
            $("[id='" + id + "']").removeClass('size-active');
            $("[id='" + id + "']").removeClass('size-same');
        }
    }
}

function cleanTablePT () {
    var underbrowSize = ['32', '34', '36', '38', '40', '42'];
    var cupSize = ['A', 'B', 'C', 'D', 'E', 'F'];
    for (var i = 0; i < cupSize.length; i++) {
        for (var j = 0; j < underbrowSize.length; j++) {
            var id = '' + underbrowSize[i] + cupSize[j];
            $("[id='" + id + "']").text('');
            $("[id='" + id + "']").removeClass('size-active');
            $("[id='" + id + "']").removeClass('size-same');
        }
    }
}

function calculateTablePT (underbrowSize, cupSize) {
    var initialCupSize = cupSize;
    var initialUnderBrowSize = underbrowSize;
    var arrSizes = ['A', 'B', 'C', 'D', 'E', 'F'];
    var id = '' + underbrowSize + cupSize;
    $("[id='" + id + "']").text(id);
    $("[id='" + id + "']").addClass('size-active');

    if (underbrowSize == 43) {
        underbrowSize = underbrowSize - 1;
    }
    for (var i = underbrowSize; i < 42; i += 2) {
        if (cupSize == 'A') {
            break;
        }
        var PrevUnderbrowSize = i + 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(cupSize) - 1];
        var cupSize = prevCupSize;
        if (PrevUnderbrowSize == 42) {
            PrevUnderbrowSize++;
        }
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }

    if (initialUnderBrowSize == 43) {
        initialUnderBrowSize = initialUnderBrowSize - 1;
    }
    for (var i = initialUnderBrowSize; i > 32; i -= 2) {
        if (initialCupSize == 'F') {
            break;
        }
        var PrevUnderbrowSize = i - 2;
        var prevCupSize = arrSizes[arrSizes.indexOf(initialCupSize) + 1];
        var initialCupSize = prevCupSize;
        var id = '' + PrevUnderbrowSize + prevCupSize;
        $("[id='" + id + "']").text(id);
        $("[id='" + id + "']").addClass('size-same');
    }
}
